import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f1b34e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = {
  class: "terms",
  ref: "scrollDiv"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-3 mb-6 has-text-centered has-text-weight-semibold" }, "Do you consent to the following?", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your submitted information and device details are used to verify your identity and prevent fraud.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-5 mb-5" }, "Identify Verification and Credit Check", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, "By accepting, you consent to Arternal verifying your collected information with select third parties, including telecommunication service providers for the purpose of identity validation and risk assessment.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-6" }, "You also consent to ARTERNAL obtaining credit, financial and related personal or business information about you, including your credit report, for the purpose of assessing your creditworthiness. We will provide you with the name and address of the credit bureau upon request. This consent is effective so long as required to fulfill the purposes described in this application, the Cardholder Agreement and the Privacy Policy.", -1))
const _hoisted_9 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "columns" }
const _hoisted_11 = { class: "column" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("I consent")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _hoisted_9, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_ctx.invoice.uuid)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: _normalizeClass(["button mt-5 is-info", { 'consent-disabled' : !_ctx.scrolledToBottom }]),
              to: {name: 'InvoiceIdentityVerification', params:{uuid:_ctx.invoice.uuid}}
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["to", "class"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}